import {required,minLength,sameAs } from "vuelidate/lib/validators";  
const resetpassword = {
    data() { 
      return {  
        
        resetpasswordData: { 
          Email: "",
          Token: "",
          Password: "",
          ConfirmPassword: ""
          }, 
          FormDataType:{
            Password:{FieldName:"Password",Field:"input",FieldTitle:this.$t('resetpassword.AddEdit.Password'),FieldType:"password"}, 
            ConfirmPassword:{FieldName:"ConfirmPassword",Field:"input",FieldTitle:this.$t('resetpassword.AddEdit.ConfirmPassword'),FieldType:"password"}, 
          } 
      }
    }, 
    validations:{ 
      FormData: {   
        Password: { required,minLength: minLength(6),},  
        ConfirmPassword: { sameAsPassword: sameAs('Password') }, 
      },
      userData: {   
        FirstName: { required},  
        LastName: { required},   
      }
 
  },
}
export default resetpassword